var _circle, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.64844,
    cy: 6.5,
    r: 5.28,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.44
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.84766,
    y1: 6.5676,
    x2: 11.4477,
    y2: 6.5676,
    stroke: "currentColor",
    strokeWidth: 1.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24805 4.68926L6.64805 1.7002L9.04805 4.68926V8.18487L6.64805 11.3002L4.24805 8.18487V4.68926Z",
    stroke: "currentColor",
    strokeWidth: 1.44
  })));
};
export default SvgGlobe;